<template>
  <div class="row">
    <div class="col-md-12 pad-to-5">
      <pos-screen-form :route="route" @on-submit="onUserSubmit"></pos-screen-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import PosScreenForm from './PosScreenForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      PosScreenForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        posScreenFormModel: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onUserSubmit (model, isValid) {
        this.posScreenFormModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/PosScreen/PosScreenAdd.vue